'use strict';

import React from 'react';
import { connect } from 'react-redux';
import
{
	titleSelector,
	envSelector
} from '../../selectors';

import
{
	updateLocation
} from '../../actions';

// TODO: conditional import this
// import { DevTools, DebugPanel, LogMonitor } from 'redux-devtools/lib/react';

class RootHandler extends React.Component {

	
	componentWillMount() {
		this.context.store.dispatch(updateLocation(this.props.location));
	}
	
	getChildContext() {
		return { env: this.props.env };
	}

	componentWillReceiveProps(nextProps, nextState) {
		this.context.store.dispatch(updateLocation(nextProps.location));
	}

	componentDidUpdate(prevProps, prevState) {
		if(this.props.title !== prevProps.title) {
			document.title = this.props.title;
		}
	}
	/*
	renderDebugTools() {
		const store = this.context.redux;
		return (<DebugPanel top={true} left={true} bottom={true}>
							<DevTools store={store} monitor={LogMonitor} />
						</DebugPanel>);
	}
	{this.renderDebugTools()}
	*/
	render() {
		return (<div className="svtse_page__app-full-height">{this.props.children}</div>);
	}
}

RootHandler.contextTypes = {
	location: React.PropTypes.object.isRequired,
	store: React.PropTypes.object.isRequired
};

RootHandler.childContextTypes = {
	env: React.PropTypes.object.isRequired
};


function select(state) {
	return {
		title: titleSelector(state),
		env: envSelector(state)
	};
}

export default connect(select)(RootHandler);




/** WEBPACK FOOTER **
 ** ./app/components/RootHandler/index.js
 **/